import { render, staticRenderFns } from "./Propagate_look.vue?vue&type=template&id=5b9d1124&style=true"
import script from "./Propagate_look.vue?vue&type=script&lang=js"
export * from "./Propagate_look.vue?vue&type=script&lang=js"
import style0 from "./Propagate_look.vue?vue&type=style&index=0&id=5b9d1124&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports